import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore.js'
import Login from './pages/Login'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Members from './pages/members/Members'
import MemberDetail from './pages/members/MemberDetail'
import MemberForm from './pages/members/MemberForm'
import Savings from './pages/savings/Savings'
import SavingsDetail from './pages/savings/SavingsDetail'
import SimpananBungaHarian from './pages/savings/SimpananBungaHarian'
import SimpananBerjangka from './pages/simpanan/SimpananBerjangka'
import Loans from './pages/loans/Loans'
import LoanDetail from './pages/loans/LoanDetail'
import LoanApply from './pages/loans/LoanApply'
import LoanDisbursement from './pages/loans/LoanDisbursement'
import LoanPayment from './pages/loans/LoanPayment'
import Profile from './pages/settings/Profile'
import Pengurus from './pages/settings/Pengurus'
import Config from './pages/settings/Config'
import COA from './pages/settings/COA'
import Lingkungan from './pages/settings/Lingkungan'
import UserManagement from './pages/settings/UserManagement'
import IncidentalLoanSettings from './pages/settings/IncidentalLoanSettings'
import ExitValidations from './pages/members/ExitValidations'
import NewMemberTransaction from './pages/members/NewMemberTransaction'
import MemberCard from './pages/members/MemberCard'
import SetoranReguler from './pages/savings/SetoranReguler'
import JurnalUmum from './pages/reports/JurnalUmum'
import JurnalUmumTransaction from './pages/transactions/JurnalUmum'
import PenarikanSimpanan from './pages/transactions/PenarikanSimpanan'
import BukuBesar from './pages/reports/BukuBesar'
import Neraca from './pages/reports/Neraca'
import LabaRugi from './pages/reports/LabaRugi'
import CashFlow from './pages/reports/CashFlow'
import Simpanan from './pages/reports/Simpanan'
import Pinjaman from './pages/reports/Pinjaman'
import Keanggotaan from './pages/reports/Keanggotaan'
import SaldoSimpanan from './pages/reports/SaldoSimpanan'
import SHU from './pages/reports/SHU'
import SHUCalculation from './pages/shu/SHUCalculation'
import IncidentalLoans from './pages/incidentalLoans/IncidentalLoans'
import IncidentalLoanApply from './pages/incidentalLoans/IncidentalLoanApply'
import IncidentalLoanDetail from './pages/incidentalLoans/IncidentalLoanDetail'
import IncidentalLoanDisbursement from './pages/incidentalLoans/IncidentalLoanDisbursement'
import IncidentalLoanPayment from './pages/incidentalLoans/IncidentalLoanPayment'
import IncidentalLoanTopup from './pages/incidentalLoans/IncidentalLoanTopup'
import MemberDashboard from './pages/member/MemberDashboard'
import BarangList from './pages/serbaUsaha/BarangList'
import TransaksiBaru from './pages/serbaUsaha/TransaksiBaru'
import DaftarTransaksi from './pages/serbaUsaha/DaftarTransaksi'
import PembayaranKredit from './pages/serbaUsaha/PembayaranKredit'
import StokMasuk from './pages/serbaUsaha/StokMasuk'
import Laporan from './pages/serbaUsaha/Laporan'
import Pengaturan from './pages/serbaUsaha/Pengaturan'
import UangPangkal from './pages/UangPangkal'

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuthStore()
  return isAuthenticated ? children : <Navigate to="/login" replace />
}

function HomeRoute() {
  const { user } = useAuthStore()
  if (user?.role === 'member') {
    return <Navigate to="/member/dashboard" replace />
  }
  return <Dashboard />
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }>
          <Route index element={<HomeRoute />} />
          <Route path="member/dashboard" element={<MemberDashboard />} />
          <Route path="members" element={<Members />} />
          <Route path="members/new" element={<MemberForm />} />
          <Route path="/members/transaction" element={<NewMemberTransaction />} />
          <Route path="/savings/setoran-reguler" element={<SetoranReguler />} />
          <Route path="/transactions/penarikan-simpanan" element={<PenarikanSimpanan />} />
          <Route path="/transactions/jurnal-umum" element={<JurnalUmumTransaction />} />
          <Route path="/members/validasi-keluar" element={<ExitValidations />} />
          <Route path="/members/card" element={<MemberCard />} />
          <Route path="/reports/jurnal" element={<JurnalUmum />} />
          <Route path="members/:nba" element={<MemberDetail />} />
          <Route path="members/:nba/edit" element={<MemberForm />} />
          <Route path="savings" element={<Savings />} />
          <Route path="savings/:noRekening" element={<SavingsDetail />} />
          <Route path="savings/sibuhar" element={<SimpananBungaHarian />} />
          <Route path="savings/berjangka" element={<SimpananBerjangka />} />
          <Route path="simpanan-berjangka" element={<SimpananBerjangka />} />
          <Route path="simpanan-berjangka" element={<SimpananBerjangka />} />
          <Route path="loans/reguler" element={<Loans />} />
          <Route path="loans/new" element={<LoanApply />} />
          <Route path="loans/disbursement" element={<LoanDisbursement />} />
          <Route path="loans/payment" element={<LoanPayment />} />
          <Route path="loans/:noPinjaman" element={<LoanDetail />} />
          <Route path="settings/profile" element={<Profile />} />
          <Route path="settings/pengurus" element={<Pengurus />} />
          <Route path="settings/config" element={<Config />} />
          <Route path="settings/coa" element={<COA />} />
          <Route path="settings/lingkungan" element={<Lingkungan />} />
          <Route path="settings/users" element={<UserManagement />} />
          <Route path="settings/incidental-loan" element={<IncidentalLoanSettings />} />
          <Route path="reports/jurnal" element={<JurnalUmum />} />
          <Route path="reports/buku-besar" element={<BukuBesar />} />
          <Route path="reports/neraca" element={<Neraca />} />
          <Route path="reports/laba-rugi" element={<LabaRugi />} />
          <Route path="reports/cashflow" element={<CashFlow />} />
          <Route path="reports/simpanan" element={<Simpanan />} />
          <Route path="reports/pinjaman" element={<Pinjaman />} />
          <Route path="reports/keanggotaan" element={<Keanggotaan />} />
          <Route path="reports/saldo-simpanan" element={<SaldoSimpanan />} />
          <Route path="reports/shu" element={<SHU />} />
          <Route path="shu/calculation" element={<SHUCalculation />} />
          <Route path="incidental-loans" element={<IncidentalLoans />} />
          <Route path="incidental-loans/new" element={<IncidentalLoanApply />} />
          <Route path="incidental-loans/disbursement" element={<IncidentalLoanDisbursement />} />
          <Route path="incidental-loans/payment" element={<IncidentalLoanPayment />} />
          <Route path="incidental-loans/topup" element={<IncidentalLoanTopup />} />
          <Route path="incidental-loans/:NoPinjaman" element={<IncidentalLoanDetail />} />
          <Route path="serba-usaha/barang" element={<BarangList />} />
          <Route path="serba-usaha/transaksi-baru" element={<TransaksiBaru />} />
          <Route path="serba-usaha/transaksi" element={<DaftarTransaksi />} />
          <Route path="serba-usaha/pembayaran" element={<PembayaranKredit />} />
          <Route path="serba-usaha/stok-masuk" element={<StokMasuk />} />
          <Route path="serba-usaha/laporan" element={<Laporan />} />
          <Route path="serba-usaha/pengaturan" element={<Pengaturan />} />
          <Route path="uang-pangkal" element={<UangPangkal />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
